export enum FlowBuilderPage {
    Flow = "Flow",
    Tree = "Tree",
    Data = "Data",
    OutputData = "OutputData",
    Configuration = "Config",
    Test = "Test",
}
